import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import {
    FaChevronRight,
    FaHeart,
    FaRegEnvelope,
    FaTimes,
} from 'react-icons/fa';
import { FiThumbsUp } from 'react-icons/fi';
import { BiCommentDetail } from 'react-icons/bi';
import { MdEmail, MdLocalPhone, MdPhone } from 'react-icons/md';

import {
    getWidgetPosition,
    isValidPrice,
    makeStatsRequestThrottled,
    applyImportantStyles,
} from '../../lib';
import { WIDGET_STATS_SETTINGS } from '../../config';
import { CLICK_ACTIONS, WIDGET_ACTIONS } from '../../constants';
import Channel from '../channel/Channel';
import { NoAvailablePrices } from 'features/noAvailablePrices';
import ToggleWidgetRoundBtn from '../common/toggleWidgetRoundBtn/ToggleWidgetRoundBtn';

import { openDrawer } from '../../features/drawersSlice';

import './DesktopBookingWidget.css';
import Button from '../common/button/Button';
import { OffersButton } from '../offers';
import { OldWidgetLoadingIndicator } from 'components/common/oldWidgetLoadingIndicator';
import Stars from '../common/stars/Stars';
import Rate from '../rate/Rate';
import { openModal } from 'features/modalSlice';
import { useOpenOldWidget } from 'hooks';
import { BookButton } from 'components/bookButton';

const DesktopBookingWidget = ({
    showWidget,
    toggleWidget,
    singleProperty,
    onClickParam,
    isBookingEngine = false,
}) => {
    const isOpen = useSelector((state) => state.miniBookingWidget.open);
    const hidden = useSelector((state) => state.miniBookingWidget.hidden);
    const data = useSelector((state) => state.miniBookingWidget?.data) || {};

    const dispatch = useDispatch();

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    // const closeBtnCntRef = useRef(null);

    // const handleWidgetContentonMouseOver = () => {
    //     closeBtnCntRef.current.classList.add('visible');
    // };

    // const handleWidgetContentonMouseLeave = (event) => {
    //     closeBtnCntRef.current.classList.remove('visible');
    // };

    const {
        Behavior: clickAction,
        ourPrice: dataOurPrice,
        ourOffers,
        colors,

        toggleWidgetRoundBtn,
        closeBtn: closeWidgetBtn,
        enableXButton: enableXBtn,
        findLowestPriceMessage: lowestPriceMessage,
        propertyID: dataPropertyId,
        actions = [],
        bookingRefText: dataBookingRefText,

        noPricesMessage,
        propertyName: dataPropertyName,
    } = data;

    const { guestScore: dataTotalScore, totalReviews: dataTotalReviews } =
        useSelector((state) => state.reviews) || {};

    const ourPrice = singleProperty ? singleProperty.ourPrice : dataOurPrice;
    const propertyId = singleProperty
        ? singleProperty.propertyID
        : dataPropertyId;
    const bookingRefText = singleProperty
        ? singleProperty.bookingRefText
        : dataBookingRefText;
    const totalScore = singleProperty
        ? singleProperty.totalScore
        : dataTotalScore;
    const totalReviews = singleProperty
        ? singleProperty.totalReviews
        : dataTotalReviews;
    const propertyName = singleProperty
        ? singleProperty.propertyName
        : dataPropertyName;
    const channels = singleProperty
        ? singleProperty?.channels
        : useSelector((state) => state.miniBookingWidget?.channels) || {};
    const show = useSelector((state) => state.miniBookingWidget.show);
    const showOffer = data?.enableWidgetOffers;
    const widgetPosition = useSelector(
        (state) => state.miniBookingWidget.widgetPosition
    );
    const showScoresComments = data?.showScoresComments;

    const showScoreAndReviews =
        (totalScore !== '' || totalReviews !== '') && showScoresComments;

    const widgetPositionStyles = getWidgetPosition(widgetPosition);
    const desktopWidgetStyles = {
        ...widgetPositionStyles,
        display: hidden ? 'none' : 'block',
    };

    const { showLoader: showOldWidgetLoader, clickHandler: openOldWidget } =
        useOpenOldWidget();
    const handleClick = useCallback(() => {
        if (clickAction === CLICK_ACTIONS.OPEN_BIG_PLUGIN) {
            dispatch(openDrawer({ drawerId: 'BigBookingWidgetDrawer' }));
        } else {
            openOldWidget(clickAction);
        }
        makeStatsRequestThrottled(
            WIDGET_STATS_SETTINGS.actions.click,
            propertyId
        );
    }, [clickAction, dispatch, propertyId]);

    const onClick = onClickParam || handleClick;

    const chatBtnHandleClick = useCallback(() => {
        openOldWidget(CLICK_ACTIONS.OPEN_CHAT);
    }, []);

    if (!show) {
        return null;
    }

    const inlineStyles = {};
    if (data.pluginZIndex) {
        inlineStyles.zIndex = data.pluginZIndex;
    }

    const onClickOffer = (event) => {
        event.stopPropagation();
        dispatch(
            openModal({
                modalId: 'OfferModal',
            })
        );
    };

    const hasPrices = ourPrice?.price || ourPrice?.loyaltyprice;
    const showLowestPriceMessage = hasPrices && lowestPriceMessage;
    const showNoPricesMessage = !hasPrices && noPricesMessage;
    const doNothingClick = (event) => {
        if (clickAction === 'link') {
            event.stopPropagation();
        }
    };
    function renderActionBtns(actions) {
        if (actions.length > 0) {
            return actions.map((action, index) => {
                let icon;
                let title;
                let onClick;
                let isLink = true;
                let href;

                switch (action.type) {
                    case WIDGET_ACTIONS.EMAIL:
                        icon = <FaRegEnvelope />;
                        title = 'Email';
                        href = `mailto:${action.value}`;
                        break;
                    case WIDGET_ACTIONS.EMAIL_FORM:
                        icon = <MdEmail />;
                        title = 'Email';
                        isLink = false;

                        onClick = (event) => {
                            event.stopPropagation();
                            if (clickAction === CLICK_ACTIONS.OPEN_BIG_PLUGIN) {
                                dispatch(
                                    openModal({
                                        modalId: 'ContactUsModal',
                                    })
                                );
                            } else {
                                openOldWidget(CLICK_ACTIONS.OPEN_EMAIL_FORM);
                            }
                        };
                        break;
                    case WIDGET_ACTIONS.CLICK_2_CALL:
                        icon = <MdPhone />;
                        title = 'Click to call';
                        isLink = false;
                        onClick = (event) => {
                            event.stopPropagation();
                            // openOldWidget(CLICK_ACTIONS.OPEN_CLICK_2_CALL);
                            if (clickAction === CLICK_ACTIONS.OPEN_BIG_PLUGIN) {
                                dispatch(
                                    openModal({
                                        modalId: 'Click2CallModal',
                                    })
                                );
                            }
                        };
                        break;
                    case WIDGET_ACTIONS.TEL:
                        icon = <MdLocalPhone />;
                        title = 'Call';
                        isLink = false;
                        onClick = (event) => {
                            event.stopPropagation();
                            makeStatsRequestThrottled(
                                WIDGET_STATS_SETTINGS.actions.phone,
                                propertyId
                            );
                            window.location.href = `tel:${action.value}`;
                        };
                        break;
                    case WIDGET_ACTIONS.MESSENGER:
                        icon = <BiCommentDetail />;
                        title = 'Messenger';
                        onClick = (event) => {
                            event.stopPropagation();

                            const popupWindowWidth = 704;
                            const popupWindowHeight = 510;
                            // center popup window
                            const left = (screen.width - popupWindowWidth) / 2;
                            const top = (screen.height - popupWindowHeight) / 2;
                            const params = `width=${popupWindowWidth}, height=${popupWindowHeight}, left=${left}, top=${top}`;
                            window.open(action.value, 'Messenger', params);
                        };
                        isLink = false;
                        break;
                    default:
                        break;
                }
                return isLink === true ? (
                    <a
                        href={href}
                        className="ab-button ab-button--action"
                        title={title}
                        key={index}
                        onClick={(event) => event.stopPropagation()}
                    >
                        {icon}
                    </a>
                ) : (
                    <Button
                        icon={icon}
                        key={index}
                        size={16}
                        className="ab-button--action"
                        title={title}
                        onClick={onClick}
                    />
                );
            });
        }

        return null;
    }

    return (
        <div
            className={`ab-desktop-widget ${
                isBookingEngine ? 'ab-desktop-small' : ''
            }`}
            style={inlineStyles}
            ref={(el) => {
                applyImportantStyles(el, desktopWidgetStyles);
            }}
        >
            <OffersButton offers={ourOffers} />
            {isOpen && (
                <div
                // onMouseOver={handleWidgetContentonMouseOver}
                // onMouseLeave={handleWidgetContentonMouseLeave}
                >
                    <div className="ab-desktop-widget-top-section">
                        <OffersButton offers={ourOffers} isOpen />

                        <div
                            className="ab-desktop-widget-close-btn visible"
                            onClick={toggleWidget}
                            // ref={closeBtnCntRef}
                        >
                            <button
                                className="ab-desktop-widget-close-btn--button"
                                ref={(el) => {
                                    applyImportantStyles(el, {
                                        'background-color':
                                            colors.secondaryBackgroundColor,
                                        'border-radius': '16px',
                                        color: colors.primaryTextColor,
                                    });
                                }}
                            >
                                <span
                                    style={{ color: colors.primaryTextColor }}
                                >
                                    {closeWidgetBtn?.text}
                                </span>
                                <span
                                    style={{ color: colors.primaryTextColor }}
                                >
                                    <FaTimes />
                                </span>
                            </button>
                        </div>
                    </div>

                    <div
                        className="ab-desktop-widget-content"
                        onClick={onClick}
                    >
                        <div
                            className="ab-desktop-widget-header"
                            style={{
                                backgroundColor: colors.primaryBackgroundColor,
                                color: colors.primaryTextColor,
                                // height: showScoreAndReviews ? '114px' : '85px',
                            }}
                        >
                            <div className="ab-desktop-widget-header-top">
                                <div>
                                    {propertyName && (
                                        <div
                                            className="ab-desktop-widget-booking-ref-text"
                                            style={{
                                                color: colors.primaryTextColor,
                                                marginBottom: '8px',
                                            }}
                                        >
                                            {propertyName}
                                        </div>
                                    )}
                                    {bookingRefText && (
                                        <div
                                            className="ab-desktop-widget-booking-ref-text"
                                            style={{
                                                color: colors.primaryTextColor,
                                            }}
                                        >
                                            {bookingRefText}
                                        </div>
                                    )}
                                </div>

                                {actions.length > 0 && !isBookingEngine && (
                                    <div className="ab-action-btns">
                                        {renderActionBtns(actions)}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="ab-desktop-widget-body">
                            <div
                                className={`ab-desktop-widget-card ${
                                    (showNoPricesMessage || propertyName) &&
                                    'small-minus-margin-top'
                                }`}
                            >
                                <div className="ab-widget-row">
                                    {showNoPricesMessage ? (
                                        <NoAvailablePrices
                                            message={noPricesMessage}
                                        />
                                    ) : (
                                        <div className="ab-desktop-widget-rates">
                                            <Rate
                                                className="ab-desktop-widget-rate--members"
                                                currencySymbol={
                                                    ourPrice?.currencySymbol
                                                }
                                                icon={<FaHeart size={14} />}
                                                link={clickAction === 'link'}
                                                // onClick={onClick}
                                                price={ourPrice?.loyaltyprice}
                                                rateType={'Member Rate'}
                                                text={ourPrice?.loyaltytext}
                                                url={ourPrice?.loyaltyurl}
                                            />

                                            {isValidPrice(
                                                ourPrice?.loyaltyprice
                                            ) &&
                                                ourPrice?.price && (
                                                    <hr
                                                        className="ab-horizontal-divider"
                                                        style={{
                                                            margin: '5px 0',
                                                            borderColor:
                                                                '#c1b8b8',
                                                            borderTopStyle:
                                                                'solid',
                                                        }}
                                                    />
                                                )}

                                            <Rate
                                                currencySymbol={
                                                    ourPrice?.currencySymbol
                                                }
                                                icon={<FiThumbsUp size={14} />}
                                                link={clickAction === 'link'}
                                                // onClick={onClick}
                                                price={ourPrice?.price}
                                                rateType={ourPrice?.text}
                                                text={Lang?.directPrice}
                                                url={ourPrice?.url}
                                            />
                                            {!isBookingEngine && (
                                                <>
                                                    <BookButton
                                                        currencySymbol={
                                                            ourPrice?.currencySymbol
                                                        }
                                                        price={`${ourPrice?.lowestPrice}`}
                                                        text={Lang?.bookNowText}
                                                        url={
                                                            ourPrice?.url
                                                                ? ourPrice?.url
                                                                : ' '
                                                        }
                                                        variant="non-member"
                                                        className="full-width fs-14"
                                                        onClick={doNothingClick}
                                                        isDirect={
                                                            clickAction !==
                                                            'link'
                                                        }
                                                        noRedirect={
                                                            clickAction !==
                                                            'link'
                                                        }
                                                    />
                                                    {showOffer && (
                                                        <div
                                                            role="button"
                                                            className={`ab-book-button ab-book-button--offer full-width fs-14`}
                                                            tabIndex="0"
                                                            aria-disabled="false"
                                                            onClick={
                                                                onClickOffer
                                                            }
                                                        >
                                                            <div className="ab-book-button-container">
                                                                <div className="ab-book-button-content">
                                                                    <span>
                                                                        {
                                                                            Lang?.getASecretOffer
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* {showLowestPriceMessage && (
                                    <div
                                        className="ab-lowest-price-msg ab-lowest-price-msg--desktop"
                                        style={{ display: 'none' }}
                                    >
                                        {lowestPriceMessage}
                                    </div>
                                )} */}
                            </div>
                            <div className="ab-desktop-widget-card ab-no-padding">
                                {hasPrices && (
                                    <div className="ab-desktop-card-inner">
                                        <div className="ab-widget-row">
                                            {channels.length > 0 && (
                                                <div className="ab-desktop-widget-channels">
                                                    {channels.map(
                                                        (channel, index) => {
                                                            let styles = {};
                                                            if (index >= 3) {
                                                                styles = {
                                                                    marginTop:
                                                                        '5px',
                                                                };
                                                            }
                                                            return (
                                                                <>
                                                                    <Channel
                                                                        // url={channel?.url}
                                                                        disablePointerEvents={
                                                                            false
                                                                        }
                                                                        // handleClick={onClick}
                                                                        logo={
                                                                            channel?.logo
                                                                        }
                                                                        name={
                                                                            channel?.name
                                                                        }
                                                                        currencySymbol={
                                                                            channel?.currencySymbol
                                                                        }
                                                                        price={
                                                                            channel?.price
                                                                        }
                                                                        key={
                                                                            channel?.channelID
                                                                        }
                                                                        extraClasses={[
                                                                            'ab-channel--desktop',
                                                                        ]}
                                                                        styles={{
                                                                            ...styles,
                                                                        }}
                                                                        channelId={
                                                                            channel?.channelID
                                                                        }
                                                                        logoSize={
                                                                            16
                                                                        }
                                                                    />
                                                                </>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            )}
                                            {showLowestPriceMessage && (
                                                <div className="ab-lowest-price-msg ab-lowest-price-msg--desktop">
                                                    {lowestPriceMessage}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {/* TODO: WHAT ABOUT useCallback */}
                                {showScoreAndReviews && (
                                    <div
                                        // onClick={(event) => {
                                        //     event.stopPropagation();
                                        //     dispatch(toggleReviewsDrawer());
                                        // }}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            dispatch(
                                                openModal({
                                                    modalId: 'ReviewsModal',
                                                })
                                            );
                                        }}
                                        className="ab-desktop-widget-card-reviews ab-wrapper-hover"
                                    >
                                        <div className="ab-widget-row">
                                            <div className="ab-desktop-offer-button">
                                                {totalScore && (
                                                    <Stars
                                                        rating={1}
                                                        size={15}
                                                        extraClass="desktop-single-widget"
                                                    />
                                                )}
                                                <div className="ab-get-offer-button-text">
                                                    {totalScore && (
                                                        <span
                                                            style={
                                                                {
                                                                    // color: colors.primaryTextColor,
                                                                }
                                                            }
                                                        >
                                                            {
                                                                totalScore.split(
                                                                    '/'
                                                                )[0]
                                                            }
                                                        </span>
                                                    )}
                                                    {totalScore &&
                                                        totalReviews && (
                                                            <span
                                                                style={{
                                                                    paddingLeft:
                                                                        '1px',
                                                                }}
                                                            >
                                                                /
                                                            </span>
                                                        )}
                                                    {totalReviews && (
                                                        <span
                                                            className="ab-desktop-widget-reviews-total ab-get-offer-button-text"
                                                            style={
                                                                {
                                                                    // color: colors.primaryTextColor,
                                                                }
                                                            }
                                                        >
                                                            10
                                                            {/* {totalReviews}{' '} */}
                                                        </span>
                                                    )}
                                                </div>
                                                {totalReviews && (
                                                    <span className="ab-desktop-widget-reviews ab-get-offer-button-text ab-offer-reviews-text">
                                                        {Lang?.reviews}
                                                    </span>
                                                )}
                                            </div>
                                            <span className="ab-icon">
                                                <FaChevronRight size={14} />
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* {showOffer && (
                                <div
                                    onClick={onClickOffer}
                                    className="ab-desktop-widget-card ab-wrapper-hover"
                                >
                                    <div className="ab-widget-row">
                                        <div className="ab-desktop-offer-button ab-offer-icon-wrapper">
                                            {
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignIitems: 'center',
                                                        justifyContent:
                                                            'center',
                                                        marginBottom: '2px',
                                                    }}
                                                >
                                                    <FaGift
                                                        color={
                                                            'rgb(247, 200, 82)'
                                                        }
                                                        size={15}
                                                    />
                                                </div>
                                            }
                                            <span className="ab-get-offer-button-text">
                                                {Lang?.getASecretOffer}
                                            </span>
                                        </div>
                                        <span className="ab-icon">
                                            <FaChevronRight size={14} />
                                        </span>
                                    </div>
                                </div>
                            )} */}
                        </div>
                        {/* <div className="ab-desktop-widget-footer">
                            <div
                                className="ab-desktop-offer-button"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                ref={(el) => {
                                    applyImportantStyles(el, {
                                        'font-size': '12px',
                                    });
                                }}
                            >
                                <span
                                    ref={(el) => {
                                        applyImportantStyles(el, {
                                            'font-size': '12px',
                                            color: 'black',
                                        });
                                    }}
                                >
                                    Powered by &nbsp;
                                </span>
                               
                            </div>
                        </div> */}

                        {showOldWidgetLoader && <OldWidgetLoadingIndicator />}
                    </div>

                    {!data.disableLogo && (
                        <div className="ab-sub-widget-footer">
                            <a
                                href={data.LogUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{}}
                            >
                                <img
                                    src={data.CustomLogo}
                                    alt=""
                                    style={{
                                        width: '80px',
                                    }}
                                    ref={(el) => {
                                        applyImportantStyles(el, {
                                            display: 'unset',
                                            float: 'unset',
                                        });
                                    }}
                                />
                            </a>
                        </div>
                    )}
                </div>
            )}

            <ToggleWidgetRoundBtn
                chatBtnOnClick={chatBtnHandleClick}
                toggleWidgetRoundBtn={toggleWidgetRoundBtn}
                toggleWidget={toggleWidget}
                widgetPosition={widgetPosition}
                showWidget={showWidget}
                enableXBtn={enableXBtn}
                ourPrice={ourPrice}
                showOnlyWhenClosed={toggleWidgetRoundBtn?.showOnlyWhenClosed}
                showCta={false}
            />
        </div>
    );
};

DesktopBookingWidget.propTypes = {
    showWidget: PropTypes.func.isRequired,
    toggleWidget: PropTypes.func.isRequired,
    singleProperty: PropTypes.object,
    onClickParam: PropTypes.func,
    isBookingEngine: PropTypes.bool,
};

export default DesktopBookingWidget;
